import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useReducer, useRef, useState } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { useTimedFlag } from '../../utils/time';
import { Button } from '../Button';
import { Canvas } from '../Canvas';
import { FullscreenButton } from '../FullscreenButton';
import { Hud } from '../Hud';
import { SpeakerIcon } from '../Icon';
import { LoadingIndicator } from '../LoadingIndicator';
import { Stage } from '../Stage';
import { ViewerPreLive } from '../ViewerPreLive';
const GlobalStyle = createGlobalStyle `
    body {
        --Stage_PaddingTop: 0rem;
        --Stage_PaddingBottom: 0rem;
        --Stage_PaddingLeft: 0rem;
        --Stage_PaddingRight: 0rem;
    }
`;
export function EmbeddedView({ streamId }) {
    const [ready, setReady] = useReducer(() => true, false);
    const canvasControllerRef = useRef(null);
    const [isHudVisible, showHud] = useTimedFlag(true, 5000);
    const [root, setRoot] = useState(null);
    const [isAudioOnMute, setIsAudioOnMute] = useState();
    const [isVideoStreaming, setIsVideoStreaming] = useTimedFlag(false, 5000);
    return (_jsxs(_Fragment, { children: [_jsx(GlobalStyle, {}), _jsxs(EmbeddedViewRoot, { ref: setRoot, onMouseDown: () => {
                    showHud();
                }, children: [_jsx(LoadingIndicator, { loading: !ready }), _jsxs(Stage, { children: [_jsx(Canvas, { controllerRef: canvasControllerRef, onMuteChange: setIsAudioOnMute, onReady: setReady, streamId: streamId, onReceivedFrame: () => {
                                    setIsVideoStreaming();
                                } }), !isVideoStreaming && (_jsx(ViewerPreLive, { roundedCorners: false }))] }), _jsxs(EmbeddedHud, { visible: isHudVisible, children: [_jsx(TopUi, { children: _jsx("div", { children: _jsx(FullscreenButton, { element: root }) }) }), _jsx("div", {}), _jsx(BottomUi, { children: _jsx(Button, { type: "button", shape: "pill", padding: "none", kind: isAudioOnMute ? undefined : 'secondary', variant: isAudioOnMute ? undefined : 'dark', icon: _jsx(SpeakerIcon, { muted: isAudioOnMute }), onClick: () => {
                                        if (!isAudioOnMute) {
                                            canvasControllerRef.current?.mute();
                                        }
                                        else {
                                            canvasControllerRef.current?.unmute();
                                        }
                                    } }) })] })] })] }));
}
const Ui = styled.div `
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.75rem;
`;
const TopUi = styled(Ui) `
    button {
        pointer-events: all;
    }
`;
const BottomUi = styled(Ui) `
    > * {
        pointer-events: all;
    }
`;
const EmbeddedHud = styled(Hud) `
    display: grid;
    grid-template-rows: auto 1fr auto;
    padding: 1.25rem;
    box-sizing: border-box;
`;
const EmbeddedViewRoot = styled.div `
    width: 100vw;
    height: 100vh;
    position: relative;
`;
